export function mapValuesDeep<T>(obj: T, callback: (value: any, obj: T) => any): T {
  const result: any = Array.isArray(obj) ? [] : {};

  if (Array.isArray(obj)) return obj.map((v) => mapValuesDeep(v, callback)) as T;
  else if (typeof obj === "object" && obj !== null)
    for (const key in obj) result[key] = mapValuesDeep(obj[key] as any, callback);
  else return callback(obj, obj);

  return result;
}
